<template>
  <div class="ls-onboarding-leads-view-parent">
    <header class="ls-onboarding-leads-view-parent--header">
      <img
        class="ls-onboarding-leads-view-parent--wordmark"
        :src="isLawnStarter ? lsLogo : ''"
        :alt="brandName"
      />
    </header>
    <div class="container"><RouterView /></div>
  </div>
</template>

<script>
import { themedComponentMixin } from '@/mixins';
import LsLogo from '@/assets/lawnstarter.svg';

export default {
  name: 'OnboardingLeadsParentView',
  mixins: [themedComponentMixin],
  data() {
    return {
      lsLogo: LsLogo,
    };
  },
};
</script>

<style lang="scss" scoped>
.ls-onboarding-leads-view-parent {
  height: 100vh;
}

.ls-onboarding-leads-view-parent--header {
  height: $navbar-height;
  background: $primary;
  margin-bottom: 66px;
  display: flex;
  align-items: center;
  padding: 0 34px;
}

.ls-onboarding-leads-view-parent--wordmark {
  height: 22px;
  width: calc(22px * #{$theme-logo-ratio});
}

.container {
  border: 1px solid $special-navbar-overlay;
  max-width: 800px;
}

@media (max-width: $mobile-max-width) {
  .ls-onboarding-leads-view-parent--header {
    justify-content: center;
    margin-bottom: 24px;
  }

  .container {
    border: none;
  }
}
.themed-app {
  .ls-onboarding-leads-view-parent--header {
    background: $theme-color-primary;
  }
  .container {
    border-color: $theme-color-gray;
  }
  .ls-onboarding-leads-view-parent--wordmark {
    content: $theme-logo-white;
  }
}
</style>
